module.exports = __webpack_public_path__ + "static/media/gotrip.dc518312.jpg";